import React from "react";
import CC from "../../components/ConferenceCustom/conference";
import CardC from "../../components/ConferenceCustom/CardConference";
import CPhotos from "../../components/ConferenceCustom/ConferencePhotos";
import CVideo from "../../components/ConferenceCustom/ConferenceVideo";
import Timer from "../../components/ConferenceCustom/Timer";
import Sponsors from "../../components/ConferenceCustom/sponsors";
import RelatedEvent from "../../components/ConferenceCustom/RelatedEvent";
import InnerBanner from "../../components/OnePageComponent/InnerBanner";

const ConferenceCustom = () => {
  return (
    <>
    <div style={{background:'#dcdcdc'}}>
       <InnerBanner />
       <div style={{display:'flex', padding:'20px', alignItems: 'flex-start'}}> 
       {/* Left Section */}
       <div style={{background:'#ffffff',maxWidth:'800px',padding:'0px',marginLeft:'0px',marginTop:'0px', borderRadius: '20px 20px 0px 0px'}}>
       <CardC/>       
       <CC/>
        <CVideo/>
       <CPhotos/>
      
      </div>

      {/* Right Section (Sticky) */}
      <div style={{
        background:'#ffffff',
        maxWidth:'33%',
        height:'fit-content',
        width:'100%',
        padding:'20px',
        marginLeft:'20px',
        borderRadius:'0px',
        position: 'sticky', // Makes it sticky
        top: '20px',        // Distance from top when scrolling
        alignSelf: 'flex-start' // Ensures sticky works inside flex
      }}>
        <Timer/>
        <Sponsors/>
      </div>
      </div>
    </div>
    <div>
      <RelatedEvent/>
    </div>
    </>
  );
};

export default ConferenceCustom;